// Admin Dashboard Configuration - Using Service Account APIs
// This uses your existing secure backend APIs instead of direct Firebase connection

// Determine API URL based on environment
// CRITICAL: This function runs at RUNTIME (when called), not at build time
// This ensures hostname detection works correctly even if build-time env vars are wrong
const getApiBaseUrl = () => {
  // ALWAYS check hostname first - this is the most reliable way to determine environment
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname.toLowerCase();
    
    // Production admin dashboard URLs (exact matches for security)
    if (hostname === 'adriftchatbotv3-admin.web.app' || 
        hostname === 'adriftchatbotv3-admin.firebaseapp.com' ||
        hostname.includes('adriftchatbotv3-admin')) {
      console.log('🔧 [PRODUCTION] Using PRODUCTION API based on hostname:', hostname);
      return "https://us-central1-adriftchatbotv3.cloudfunctions.net";
    }
    
    // Staging admin dashboard URLs
    if (hostname.includes('staging') || hostname === 'localhost' || hostname.includes('127.0.0.1')) {
      console.log('🔧 [STAGING] Using STAGING API based on hostname:', hostname);
      return "https://us-central1-adrift-chatbot-staging.cloudfunctions.net";
    }
  }
  
  // Fallback: Check environment variables (only if hostname check failed)
  // NOTE: This should rarely be used since hostname check should always work in browser
  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || process.env.REACT_APP_FIRESTORE_PROJECT_ID;
  
  if (projectId === 'adrift-chatbot-staging') {
    console.warn('⚠️ Using STAGING API (env var fallback):', projectId);
    console.warn('⚠️ Hostname detection failed - this should not happen in production!');
    return "https://us-central1-adrift-chatbot-staging.cloudfunctions.net";
  }
  
  // Default to production (safest default)
  console.log('🔧 Using PRODUCTION API (default fallback)');
  return "https://us-central1-adriftchatbotv3.cloudfunctions.net";
};

export const adminConfig = {
  // API Base URL - your Firebase Functions with service account access
  // IMPORTANT: This is a getter function that runs at RUNTIME, not build time
  // This ensures hostname detection works correctly regardless of build-time env vars
  get apiBaseUrl() {
    return getApiBaseUrl();
  },
  
  endpoints: {
    ratings: "/getRatings",
    ratingAnalytics: "/getRatingAnalytics",
    ragData: "/ragData",
    ragDocuments: "/ragDocuments",
    conversations: "/getAllConversations",
    conversationDetails: "/getConversationDetails",
    messages: "/getMessages",
    deleteConversation: "/deleteConversation"
  }
};

/* 
SECURITY BENEFITS OF THIS APPROACH:
✅ Uses your service account (full admin access)
✅ No Firebase credentials exposed in browser  
✅ All your data is already accessible via these APIs
✅ No additional configuration needed!

READY TO USE:
Your backend already has all the admin endpoints set up with service account access.
Just make sure your Firebase Functions emulator is running:
> cd backend/functions && firebase emulators:start --only functions
*/
